import { render, staticRenderFns } from "./startNewsletterDialog.vue?vue&type=template&id=6a4c9f1f&scoped=true&"
import script from "./startNewsletterDialog.vue?vue&type=script&lang=js&"
export * from "./startNewsletterDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4c9f1f",
  null
  
)

export default component.exports